import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SegmentsList from '../../common/SegmentsCollapsableList';
import segments from '../../common/SegmentsCollapsableList/dataSource';
import AutoCompleteSingle from '../../common/AutoCompleteSingle';
import segmentPropTypes from '../../common/SegmentCollapsableCard/propTypes';
import {
    getUserSegments,
    getActiveSegmentId,
    getSegmentsLoading,
    getHasMoreSegments,
    getMoreSegmentsLoading,
    getSegmentPhotos,
    getSegmentPhotosLoading,
    getLandtype,
    getPartners,
    getPartnersLoading,
} from './selectors';
import {
    userSegmentsRequested,
    setActiveSegment,
    moreUserSegmentsRequested,
    resetUserSegments,
    resetUserSegmentsTags,
    partnersRequested,
} from './actions';
import './styles.scss';
import { getUser } from '../auth/selectors';
import { noop } from '../../common/propTypes';
import UserIcon from '../../icons/userIcon.svg';
import {
    DROPDOWN_VARIANTS,
    DROPDOWNDATA,
    LANDUSED_TYPE,
    SUBLAND_TYPE,
} from '../../common/constants';
import DropDown from '../../common/DropDown';
import SegmentNotes from './SegmentNotes';
import SegmentDelete from './SegmentDelete';

function Segments({
    segments,
    fetchUserSegments,
    fetchMoreUserSegments,
    onSegmentClick,
    activeSegmentId,
    loading,
    moreSegmentsLoading,
    hasMoreSegments,
    resetSegmentData,
    resetSegmentsTags,
    photos,
    loadingPhotos,
    user,
    landType,
    partners,
    fetchPartners,
}) {
    const [showNotes, setShowNotes] = useState(false);
    const [segmentOfNotes, setSegmentOfNotes] = useState(null);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [partnerSelected, setSelectedPartners] = useState({
        id: 'ALL',
        title: 'ALL',
        fullName: 'ALL', //
    });

    useEffect(() => {
        window.scrollTo(0, 0);
        resetSegmentsTags();
        fetchUserSegments(DROPDOWNDATA[0].key, 'date');
        fetchPartners();
        return resetSegmentData;
    }, []);

    const [activeSegmentIndex, setActiveSegmentIndex] = useState(0);

    useEffect(() => {
        // set's the first item as the active segment in state on page load
        // the active segment in state is used to filter segment Tags for each
        // Segment's ConnectedTags component

        // eslint-disable-next-line react/prop-types
        segments && segments.length ? onSegmentClick(segments[0].id) : null;
    }, [segments]);

    useEffect(() => {
        setActiveSegmentIndex(activeSegmentId);
    }, [activeSegmentId]);

    //eslint-disable-next-line react/prop-types
    let segmentNotes = segments.find((segment) => segment.id == segmentOfNotes);
    segmentNotes = segmentNotes ? segmentNotes.notes : '';
    return (
        <>
            <div className="segmentsHeader">
                <div className="row">
                    <h1 className="heading">Segments</h1>
                    <div className="dropdown">
                        <DropDown
                            label={'LandUse'}
                            menuData={LANDUSED_TYPE}
                            onChange={(val) =>
                                fetchUserSegments(val, 'landType')
                            }
                            variant={DROPDOWN_VARIANTS.LIST_SIMPLE}
                        />
                    </div>
                    {landType == LANDUSED_TYPE[1].key && (
                        <div className="dropdown">
                            <DropDown
                                label={''}
                                menuData={SUBLAND_TYPE}
                                onChange={(val) =>
                                    fetchUserSegments(val, 'subLandType')
                                }
                                variant={DROPDOWN_VARIANTS.LIST_SIMPLE}
                            />
                        </div>
                    )}
                    <div className="dropdown">
                        <DropDown
                            label={'Select Date'}
                            menuData={DROPDOWNDATA}
                            onChange={fetchUserSegments}
                            variant={DROPDOWN_VARIANTS.LIST_SIMPLE}
                        />
                    </div>
                    <div className="filter-partner">
                        <AutoCompleteSingle
                            //title="Users"
                            id="partner-autocomplete"
                            isLoading={false}
                            bootstrapIcon={UserIcon}
                            options={partners}
                            onSelect={(user) => {
                                if (user) {
                                    setSelectedPartners(user);
                                    fetchUserSegments(
                                        [user],
                                        'selectedPartners',
                                    );
                                } else {
                                    setSelectedPartners(user);
                                    fetchUserSegments([], 'selectedPartners');
                                }
                            }}
                            placeholder={'Type User Name'}
                            disabled={false}
                            getOptionLabel={(option) => `${option.fullName}`}
                            renderOption={(option) => option.fullName}
                            value={partnerSelected}
                        />
                    </div>
                </div>
            </div>
            <SegmentsList
                loading={loading}
                moreSegmentsLoading={moreSegmentsLoading}
                segments={segments}
                onSegmentClick={(id) => {
                    id == activeSegmentId
                        ? onSegmentClick(-1)
                        : onSegmentClick(id);
                }}
                activeSegmentId={activeSegmentIndex}
                hasMoreSegments={hasMoreSegments}
                moreSegmentsCallback={fetchMoreUserSegments}
                photos={photos}
                loadingPhotos={loadingPhotos}
                onEditClick={(id) => {
                    setSegmentOfNotes(id);
                    setShowNotes(true);
                }}
                onDeleteClick={() => {
                    setConfirmDelete(true);
                }}
                loggedInUser={user}
            />
            <SegmentNotes
                show={showNotes}
                segments={segments}
                segmentId={segmentOfNotes}
                segmentNotes={segmentNotes}
                onClose={() => {
                    setShowNotes(false);
                }}
            />

            <SegmentDelete
                show={confirmDelete}
                segmentId={activeSegmentId}
                segments={segments}
                onClose={() => {
                    setConfirmDelete(false);
                }}
            />
        </>
    );
}

Segments.propTypes = {
    segments: PropTypes.arrayOf(
        PropTypes.shape({
            ...segmentPropTypes,
        }),
    ),
    photos: PropTypes.array,
    loadingPhotos: PropTypes.bool,
    fetchUserSegments: PropTypes.func,
    fetchMoreUserSegments: PropTypes.func,
    onSegmentClick: PropTypes.func,
    activeSegmentId: PropTypes.number,
    loading: PropTypes.bool,
    hasMoreSegments: PropTypes.bool,
    moreSegmentsLoading: PropTypes.bool,
    resetSegmentData: PropTypes.func,
    resetSegmentsTags: PropTypes.func,
    user: PropTypes.object,
    landType: PropTypes.string,
    partners: PropTypes.array,
    loadingPartners: PropTypes.bool,
    fetchPartners: PropTypes.func,
};

Segments.defaultProps = {
    segments: segments,
    fetchUserSegments: noop,
    fetchMoreUserSegments: noop,
    onSegmentClick: noop,
    activeSegmentId: noop,
    loading: false,
    hasMoreSegments: true,
    moreSegmentsLoading: false,
    resetSegmentData: noop,
    resetSegmentsTags: noop,
};

const mapStateToProps = (state) => {
    return {
        segments: getUserSegments(state),
        loading: getSegmentsLoading(state),
        moreSegmentsLoading: getMoreSegmentsLoading(state),
        activeSegmentId: getActiveSegmentId(state),
        hasMoreSegments: getHasMoreSegments(state),
        photos: getSegmentPhotos(state),
        loadingPhotos: getSegmentPhotosLoading(state),
        user: getUser(state),
        landType: getLandtype(state),
        partners: getPartners(state),
        loadingPartners: getPartnersLoading(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchUserSegments: (data, attribute) =>
            dispatch(userSegmentsRequested(data, attribute)),
        fetchMoreUserSegments: () => dispatch(moreUserSegmentsRequested()),
        onSegmentClick: (activeSegmentId) =>
            dispatch(setActiveSegment(activeSegmentId)),
        resetSegmentData: () => {
            dispatch(resetUserSegments());
        },
        resetSegmentsTags: () => dispatch(resetUserSegmentsTags()),
        fetchPartners: () => dispatch(partnersRequested()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Segments);
